import axios from 'axios';

export const getNews = async (institution_code) => {
	try {
		const response = await axios.get(
			`/custom_news/${
				institution_code ? `?institution_code=${institution_code}` : ''
			}`,
			{
				headers: {
					accept: 'application/json',
					Authorization: `Bearer ${localStorage.token}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const createNews = async ({
	title,
	icon,
	imageFile,
	richText,
	category,
	description,
	institutionCodes,
}) => {
	const formData = new FormData();
	formData.append('title', title);
	formData.append('description', description);
	if (icon) formData.append('icon', icon, icon.name);
	formData.append('image', imageFile, imageFile.name);
	formData.append('rich_text', richText);
	if (category) formData.append('category', category);
	if (institutionCodes)
		formData.append('institution_codes', JSON.stringify(institutionCodes));

	try {
		const response = await axios.post('/custom_news/create', formData, {
			headers: {
				accept: 'application/json',
				Authorization: `Bearer ${localStorage.token}`,
				'Content-Type': 'multipart/form-data',
			},
		});
		return response.data;
	} catch (err) {
		throw err;
	}
};

export const getOlibsLibrariesCodes = async () => {
	try {
		const response = await axios.get('/institutions/list/codes', {
			headers: {
				accept: 'application/json',
			},
		});
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const getNewsById = async (id) => {
	try {
		const response = await axios.get(`/custom_news/get/${id}`, {
			headers: {
				accept: 'application/json',
				Authorization: `Bearer ${localStorage.token}`,
			},
		});
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const updateNewsById = async ({
	newsId,
	title,
	icons,
	imageFile,
	richText,
	category,
	description,
	institutionCodes,
}) => {
	const formData = new FormData();
	formData.append('title', title);
	formData.append('description', description);

	if (icons) {
		formData.append('icon', icons, icons.name);
	}
	if (imageFile) {
		formData.append('image', imageFile, imageFile.name);
	}
	formData.append('rich_text', richText);
	if (category) formData.append('category', category);
	if (institutionCodes) {
		formData.append('institution_codes', JSON.stringify(institutionCodes));
	}

	try {
		const response = await axios.post(
			`/custom_news/update?news_id=${newsId}`,
			formData,
			{
				headers: {
					accept: 'application/json',
					Authorization: `Bearer ${localStorage.token}`,
					'Content-Type': 'multipart/form-data',
				},
			}
		);
		return response.data;
	} catch (err) {
		throw err;
	}
};

export const desactivateNews = async (newsId) => {
	try {
		const response = await axios.delete(`/custom_news/delete/${newsId}`, {
			headers: {
				accept: 'application/json',
				Authorization: `Bearer ${localStorage.token}`,
			},
		});
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const activateNews = async (newsId) => {
	try {
		const response = await axios.post(
			`/custom_news/activate?news_id=${newsId}`,
			{
				headers: {
					accept: 'application/json',
					Authorization: `Bearer ${localStorage.token}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		throw error;
	}
};
